exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tavolos-hotelintel .tavolos-hotelintel-header[data-v-3c7223ca]{margin-bottom:20px}#tavolos-hotelintel .tavolos-hotelintel-logo img[data-v-3c7223ca]{display:block;margin:auto;max-height:60px;width:auto}#tavolos-about[data-v-3c7223ca]{margin:50px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c7223ca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HotelIntel.vue
// module id = 63
// module chunks = 0